import { Checkbox, Modal, Text } from '@mlc/web-ui-toolkit';
import React from 'react';
import { left } from 'styled-system';
import { NotificationModel } from '../../../logic/domains/notification.domain';
import notificationTestIds from './Notification.elements';

interface Props {
	notification: NotificationModel;
	closeNotification: (acknowldge: boolean) => void;
}

interface State {
	acknowledged: boolean;
}

const initialState: State = {
	acknowledged: false,
};

export class Notification extends React.Component<Props, State> {
	constructor(props: any) {
		super(props);
		this.state = initialState;
	}

	render() {
		return (
			<Modal
				align={'left'}
				title={this.props.notification.title}
				isOpen={true}
				shouldCloseOnOverlayClick={false}
				onRequestClose={() =>
					this.props.closeNotification(this.state.acknowledged)
				}
			>
				<Text
					dangerouslySetInnerHTML={{
						__html: this.props.notification.content,
					}}
					data-id={notificationTestIds.notificationContent}
				/>
				<Checkbox
					label="Don't show this message again."
					data-checkbox="unchecked"
					checked={this.state.acknowledged}
					onChange={(event: any, checkedObject: any) => {
						this.setState({
							acknowledged: checkedObject.checked,
						});
					}}
					data-id={notificationTestIds.ackCheck}
				/>
			</Modal>
		);
	}
}
